import { makeApiRequest } from 'actions/api';
import { GET_QUICK_FILTERS_V3 } from 'lib/constants/v3Actions';
import RequestService from 'services/RequestService';

export const getQuickFilters = (menuSlug, mealPlanSlug) =>
  makeApiRequest({
    requestType: GET_QUICK_FILTERS_V3,
    method: RequestService.v3.getQuickFilters,
    params: { menuSlug, mealPlanSlug },
  });
